import { styled } from '@mui/material/styles';

// VendorList styles ----------------------------------------------------------

export const FlexColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const RealmList = styled('div')({
  // Thin wrapper for the page root.
});

export const InnerContainer = styled('div')(({ theme }) => ({
  padding: `0 ${theme.spacing(4)}`,

  '& .MuiCheckbox-root': {
    padding: 1,
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
  },
}));

// TradesList styles (formerly `tradeStyles`) ---------------------------------

export const TradesContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(1),
}));
